export const assignErrorToItem = <
  TError extends {
    readonly apiErrorCode?: string;
    readonly apiErrorMessage?: string;
    readonly data?: {
      readonly sharePointItemUrl: string;
    };
    readonly errorCode?: string;
    readonly type: number;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TItem extends {
    readonly data?: {
      readonly sharePointItemUrl: string;
    };
    readonly type: number;
  },
  TReturn extends TItem & {
    readonly error: TError;
    readonly type: -1;
  }
>(
  err: TError,
  item: TItem
): TReturn => {
  const { apiErrorCode, apiErrorMessage, errorCode } = err;

  // eslint-disable-next-line prefer-object-spread
  Object.assign(item, {
    error: {
      apiErrorCode,
      apiErrorMessage,
      data: item.data,
      errorCode,
      type: item.type,
    },
    type: -1,
  });

  return item as unknown as TReturn;
};
